import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import Card from "../components/Card";
import Input from "../components/Input";
import Button from "../components/Button";
import { listSessions, startSession } from "../api/bots";
import { logout } from "../api/auth";

export default function Dashboard({ onSelectSession, onLogout, onNavigate }) {
  const [slug, setSlug] = useState("ugordi");
  const [count, setCount] = useState(5);
  const [sessions, setSessions] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  async function refresh() {
    const data = await listSessions();
    setSessions(data.sessions || []);
  }

  useEffect(() => {
    refresh().catch(() => {});
  }, []);

  async function onStart() {
    setErr("");
    setLoading(true);
    try {
      await startSession(slug, count);
      await refresh();
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  }

  function fmt(dt) {
    if (!dt) return "-";
    const d = new Date(dt);
    // TR format, saat:dakika da olsun
    return d.toLocaleString("tr-TR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  return (
    <Layout
      title="Bot Panel"
      right={
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <Button
            variant="secondary"
            onClick={() => onNavigate?.("dashboard")}
          >
            Dashboard
          </Button>

          <Button
            variant="secondary"
            onClick={() => onNavigate?.("cookies")}
          >
            Hesaplar
          </Button>

          <Button
            variant="secondary"
            onClick={() => onNavigate?.("messages")}
          >
            Mesajlar
          </Button>

          <Button
            variant="ghost"
            onClick={() => {
              logout();
              onLogout();
            }}
          >
            Çıkış
          </Button>
        </div>
      }
    >
      <div className="grid">
        <Card>
          <div className="h2">Session Başlat</div>
          <div className="stack">
            <Input label="Slug" value={slug} onChange={(e) => setSlug(e.target.value)} />
            <Input label="Bot Sayısı" type="number" value={count} onChange={(e) => setCount(e.target.value)} />
            {err ? <div className="error">{err}</div> : null}
            <Button onClick={onStart} disabled={loading}>
              {loading ? "Başlatılıyor..." : "Başlat"}
            </Button>
          </div>
        </Card>

        <Card>
          <div className="h2">Sessions</div>
          <div className="list">
            {sessions.map((s) => (
              <div key={s.id} className="row">
                <div>
                  <div className="mono">{s.id}</div>
                  <div className="muted">
                      slug: <b>{s.slug}</b> | count: <b>{s.requested_count}</b> | by: <b>{s.created_by_username}</b>
                    </div>

                    <div className="muted" style={{ marginTop: 4 }}>
                      başladı: <b>{fmt(s.created_at)}</b> {" | "}
                      {s.stopped_at ? (
                        <>bitti: <b>{fmt(s.stopped_at)}</b></>
                      ) : (
                        <>durum: <b>aktif</b></>
                      )}
                    </div>
                </div>
                <Button variant="secondary" onClick={() => onSelectSession(s.id)}>
                  Aç
                </Button>
              </div>
            ))}
            {sessions.length === 0 ? <div className="muted">Henüz session yok.</div> : null}
          </div>
        </Card>
      </div>
    </Layout>
  );
}
